module.exports = __webpack_public_path__ + "static/img/常用工具模块.ae60fb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_images/常用工具模块.png
// module id = C1Lt
// module chunks = 1